module.exports = __webpack_public_path__ + "img/rg_object_history_menu_default.3d443c95.svg";